import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { downloadFile, errMsg, nzDateTime } from "@/lib/hsUtil";
import DateInput from "@/components/DateInput";

export default function SignLogTab() {
  const [sites, setSites] = useState([]);
  const [f, setF] = useState({ project_id: "", date_from: "", date_to: "" });
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/hs/sites").then(r => setSites(r.data)); }, []);
  const load = useCallback(() => api.get("/hs/sign-log", { params: f }).then(r => setRows(r.data))
    .catch(e => toast.error(errMsg(e))), [f]);
  useEffect(() => { load(); }, [load]);
  const set = k => e => setF(x => ({ ...x, [k]: e.target.value }));
  const exp = ext => downloadFile(`/hs/sign-log.${ext}`, `site_sign_in_log.${ext}`, f).catch(e => toast.error(errMsg(e)));
  return (
    <div className="space-y-3" data-testid="hs-log-tab">
      <div className="card flex flex-wrap items-end gap-3">
        <label className="text-sm"><span className="block text-xs text-silver">Project</span>
          <select className="input" value={f.project_id} onChange={set("project_id")} data-testid="hs-log-job">
            <option value="">All projects</option>
            {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select></label>
        <label className="text-sm"><span className="block text-xs text-silver">From</span>
          <DateInput value={f.date_from} onChange={set("date_from")} data-testid="hs-log-from"/></label>
        <label className="text-sm"><span className="block text-xs text-silver">To</span>
          <DateInput value={f.date_to} onChange={set("date_to")} data-testid="hs-log-to"/></label>
        <button className="btn-ghost text-sm" onClick={() => exp("csv")} data-testid="hs-log-export-csv">Export CSV</button>
        <button className="btn-ghost text-sm" onClick={() => exp("pdf")} data-testid="hs-log-export-pdf">Export PDF</button>
      </div>
      <div className="card overflow-x-auto">
        <table className="table w-full text-sm" data-testid="hs-log-table">
          <thead><tr><th>Project</th><th>Name</th><th>Company</th><th>Type</th><th>Phone</th><th>In</th><th>Out</th><th>Inducted</th><th>Flag</th></tr></thead>
          <tbody>
            {(rows || []).map(r => (
              <tr key={r.id} data-testid={`hs-log-row-${r.id}`}>
                <td>{r.project}</td><td>{r.name}</td><td>{r.company}</td><td>{r.type}</td><td>{r.phone}</td>
                <td>{nzDateTime(r.signed_in_at)}</td><td>{nzDateTime(r.signed_out_at)}</td>
                <td>{r.inducted ? "Yes" : ""}</td>
                <td>{r.midnight_flag ? <span className="text-amber-400">Midnight auto sign-out</span> : ""}</td>
              </tr>
            ))}
            {rows && rows.length === 0 && <tr><td colSpan={9} className="opacity-60">No sign-ins for this filter.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
